import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { cva } from "class-variance-authority";
const headingVariants = cva("tracking-tight text-pretty", {
  variants: {
    level: {
      1: "text-4xl font-bold text-foreground md:text-5xl/tight",
      2: "text-3xl font-semibold text-foreground md:text-4xl/tight",
      3: "text-xl font-medium text-foreground md:text-2xl/tight",
      4: "text-lg font-medium text-muted-foreground",
      5: "text-base font-medium text-muted-foreground",
      6: "text-sm font-medium text-muted-foreground"
    }
  },
  defaultVariants: {
    level: 1
  }
});
export function Heading(t0) {
  const $ = _c(11);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      level: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const level = t1 === undefined ? 1 : t1;
  const Element = `h${level}`;
  let t2;
  if ($[4] !== className || $[5] !== level) {
    t2 = clsx(headingVariants({
      level,
      className
    }));
    $[4] = className;
    $[5] = level;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== Element || $[8] !== props || $[9] !== t2) {
    t3 = <Element {...props} className={t2} />;
    $[7] = Element;
    $[8] = props;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
const subheadingVariants = cva("text-pretty", {
  variants: {
    level: {
      1: "text-xl text-muted-foreground/90 max-w-3xl mt-4",
      2: "text-lg text-muted-foreground/80 max-w-2xl mt-3",
      3: "text-base text-muted-foreground/70 max-w-xl mt-2",
      4: "text-sm text-muted-foreground/60 max-w-lg mt-2",
      5: "text-sm text-muted-foreground/60 max-w-md mt-1",
      6: "text-xs text-muted-foreground/60 max-w-md mt-1"
    }
  },
  defaultVariants: {
    level: 2
  }
});
export function Subheading(t0) {
  const $ = _c(11);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      level: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const level = t1 === undefined ? 2 : t1;
  const Element = `h${level}`;
  let t2;
  if ($[4] !== className || $[5] !== level) {
    t2 = clsx(subheadingVariants({
      level,
      className
    }));
    $[4] = className;
    $[5] = level;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== Element || $[8] !== props || $[9] !== t2) {
    t3 = <Element {...props} className={t2} />;
    $[7] = Element;
    $[8] = props;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}